import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login.vue'
import zfLogin from '@/views/zfLogin.vue'
import Home from '@/views/home.vue'
import Personal from '@/views/personal.vue'
import WKLogin from '@/views/wkLogin.vue'
import helpCenter from '@/views/helpCenter.vue'
import { clearLoginInfo } from '@/utils'
import de from "element-ui/src/locale/lang/de";
import el from "element-ui/src/locale/lang/el";
import construction from '@/views/construction.vue'
import demo from '@/views/demo.vue'
import dingTalkAuth from '@/views/dingTalkAuth.vue'
import dingTalkBind from '@/views/DingTalkBind.vue'
import dingTalkAutoLogin from '@/views/dingTalkAutoLogin.vue'
Vue.use(Router)



const router = new Router({
  mode: 'history', // 设置为历史模式
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/zfLogin',
      name: 'zfLogin',
      component: zfLogin
    },
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/personal',
      name: 'Personal',
      component: Personal
    },
    {
      path: '/wkLogin',
      name: 'wkLogin',
      component: WKLogin
    },
    {
      path: '/helpCenter',
      name: 'helpCenter',
      component: helpCenter
    },
    {
      path: '/construction',
      name: 'construction',
      component: construction
    },
    {
      path: '/demo',
      name: 'demo',
      component: demo
    },
    {
      path: '/dingtalkauth',
      name: '/dingtalkauth',
      component: dingTalkAuth
    },
    {
      path: '/dingtalkbind/:dingtalkId',
      name: 'dingtalkbind',
      component: dingTalkBind
    },
    {
      
      path: '/dingtalkautologin',
      name: 'dingtalkautologin',
      component: dingTalkAutoLogin
    }
  ]
})
// 忽略登录路由名称集合
const ignoreLogin = ['/login','/zfLogin','/wkLogin','/','/helpCenter','/demo','/dingtalkauth','/dingtalkbind','/dingtalkautologin']

router.beforeEach((to,from,next) => {
  let href = window.location.href
  let origin = window.location.origin   // http://jbzk.ejkj.top
  let hash = window.location.hash       // #/home
  let pathname = window.location.pathname // /
  let search = window.location.search     // ?后内容
  let url = origin + pathname + hash
  if (href.includes(url)) {

    let token = Vue.cookie.get('token') == null ? sessionStorage.getItem('token') : Vue.cookie.get('token')
    if (!ignoreLogin.includes(to.path) && (!token || !/\S/.test(token)) && !to.path.includes("/dingtalkbind")) {
      clearLoginInfo()
      next({ name: 'Login' })
    }
    next()
  }else{
    url = origin + pathname + hash + pathname.substring(1,pathname.length) + search
    console.warn(url)
    window.location.href = url
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js